import React from 'react';
import { Box, Slide } from '@material-ui/core';
import { CallItem } from './CallItem';
import { useTheme } from '@material-ui/core';
import { Header } from './Header';

export const CallsList = ({
    onClose,
    calls,
}: {
    onClose: () => void;
    calls: any[];
}) => {
    const theme = useTheme();

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'calc(100vh - 80px)',
                flex: 1,
                position: 'relative',
                overflow: 'hidden',
                backgroundColor: theme.palette.background.paper,
            }}
        >
            <Slide direction="left" in={true} timeout={600}>
                <Box
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Header onClose={onClose} />
                    <div
                        style={{
                            flex: 1,
                            overflowY: 'scroll',
                            padding: '25px 25px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10,
                        }}
                    >
                        {calls.map((call) => (
                            <CallItem key={call._id} call={call} />
                        ))}
                    </div>
                </Box>
            </Slide>
        </Box>
    );
};
